import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "./AuthContext";
import {detectPathUrl} from "helpers/detectPathUrl";

export const PrivateRoute = ({ children }) => {
    const { isLoggedIn } = useAuthContext();
    if (!isLoggedIn) {
        return <Navigate to={detectPathUrl('authentication/login')} replace />;
    }

    return children ? children : <Outlet />;
};